/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMonthlyIndexV1Dto } from '../models/CreateMonthlyIndexV1Dto';
import type { MonthlyIndexV1Dto } from '../models/MonthlyIndexV1Dto';
import type { UpdateMonthlyIndexV1Dto } from '../models/UpdateMonthlyIndexV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MonthlyIndicesService {
  /**
   * @param requestBody
   * @returns MonthlyIndexV1Dto create entity
   * @throws ApiError
   */
  public static monthlyIndexControllerV1CreateV1(
    requestBody: CreateMonthlyIndexV1Dto,
  ): CancelablePromise<MonthlyIndexV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/monthly-indices',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns MonthlyIndexV1Dto a entity list
   * @throws ApiError
   */
  public static monthlyIndexControllerV1FindAllV1(): CancelablePromise<Array<MonthlyIndexV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/monthly-indices',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns MonthlyIndexV1Dto the entity
   * @throws ApiError
   */
  public static monthlyIndexControllerV1FindRecentV1(): CancelablePromise<MonthlyIndexV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/monthly-indices/recent',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid monthlyIndexId
   * @returns MonthlyIndexV1Dto the entity
   * @throws ApiError
   */
  public static monthlyIndexControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<MonthlyIndexV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/monthly-indices/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid monthlyIndexId
   * @param requestBody
   * @returns MonthlyIndexV1Dto the update entity
   * @throws ApiError
   */
  public static monthlyIndexControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: UpdateMonthlyIndexV1Dto,
  ): CancelablePromise<MonthlyIndexV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/monthly-indices/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @deprecated
   * @param uuid monthlyIndexId
   * @param requestBody
   * @returns MonthlyIndexV1Dto the update entity
   * @throws ApiError
   */
  public static monthlyIndexControllerV1UpdateV1(
    uuid: string,
    requestBody: UpdateMonthlyIndexV1Dto,
  ): CancelablePromise<MonthlyIndexV1Dto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/monthly-indices/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
